import { render, staticRenderFns } from "./ShowHonorariosTab.vue?vue&type=template&id=057ded34&scoped=true"
import script from "./ShowHonorariosTab.vue?vue&type=script&lang=js"
export * from "./ShowHonorariosTab.vue?vue&type=script&lang=js"
import style0 from "./ShowHonorariosTab.vue?vue&type=style&index=0&id=057ded34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057ded34",
  null
  
)

export default component.exports